module.exports = __webpack_public_path__ + "img/20191216161333802.31be8e86.jpg";